import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    textRight: {
      textAlign: 'right',
    },

    link: {
      '& a': {
        fontWeight: 500,
        cursor: 'pointer',
        color: theme.palette.primary.main,
      },
    },

    titleRow: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: theme.typography.pxToRem(13),
    },
    title: {
      fontWeight: 500,
      fontSize: theme.typography.pxToRem(13),
    },
    subtitle: {
      fontWeight: 'bold',
      marginRight: 10,
      fontSize: theme.typography.pxToRem(13),
    },

    name: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 500,
      color: theme.palette.text.primary,
      '& a': {
        fontWeight: 500,
        cursor: 'pointer',
        color: theme.palette.text.primary,
      },
    },

    mt10: {
      marginTop: 10,
    },

    cardContent: {
      cursor: 'pointer',
    },

    list: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      width: '100%',
      alignItems: 'flex-start',
    },

    listItem: {
      width: '100%',
      padding: '0 4px 0 0',
      '&:not(:last-of-type)': {
        borderBottom: `1px solid ${theme.palette.common.greyLight}`,
      },
    },

    divider: {
      margin: '20px 0px',
    },
  };
});

const listTextStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    primary: {
      color: theme.palette.text.subtitle,
      fontSize: theme.typography.pxToRem(13),
      fontWeight: 'bold',
      wordBreak: 'break-word',
    },

    secondary: {
      color: theme.palette.common.lightNavy,
      fontSize: theme.typography.pxToRem(13),
      wordBreak: 'break-word',
    },
  };
});

const collapseCardStyles = makeStyles({
  root: {
    marginTop: 20,
    marginBottom: 20,
    '& button': {
      borderRadius: '4px 4px 0 0',
    },
  },
  box: {
    marginTop: 0,
    borderTop: 0,
    borderRadius: '0 0 4px 4px',
  },
  buttonClass: {
    backgroundColor: '#FBFBFB',
    border: '1px solid #EEEEEE',
    boxShadow: 'none',
    color: '#4D4F5C',
    padding: '6px 24px',
    textTransform: 'capitalize',
    fontSize: '13px',
    '&:hover': {
      backgroundColor: '#FBFBFB',
      border: '1px solid #EEEEEE',
      boxShadow: 'none',
      color: '#4D4F5C',
    },
  },
});

export { useStyles, listTextStyles, collapseCardStyles };
